import React, {useRef, useEffect, useState} from 'react'
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import EmpleadoDetail from './Detail'
import dayjs from 'dayjs';
import ChangePasswordModal from './ChangePassword'
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, PlusOutlined, UploadOutlined, DownloadOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space, Segmented, Input, Dropdown, Upload, Progress, Steps} from 'antd';
import { getAll, importEmpleadosBulk, importEmpleadosConfirm, previewImportEmpleados, createMissingCatalogs } from '../../../../apis/OdooApi';

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Recursos Humanos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Captura</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <ClockCircleFilled />
        <span>Empleados</span>
      </>
    ),
}];

const EmpleadosPage = () => {
    const [items, setItems] = React.useState([]);
    const [openEdit, setOpenEdit] = React.useState(false);
    const [openDetail, setOpenDetail] = React.useState(false);
    const [openChangePassword, setOpenChangePassword] = React.useState(false);
    const [periodSelected, setPeriodSelected] = React.useState(null);
    const [statusFilter, setStatusFilter] = React.useState('active');
    const [searchText, setSearchText] = React.useState('');

    const [importing, setImporting] = useState(false);
    const [importProgress, setImportProgress] = useState(0);
    const progressTimer = useRef(null);
    const [previewData, setPreviewData] = useState(null);
    const [previewFile, setPreviewFile] = useState(null);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [creatingCatalogs, setCreatingCatalogs] = useState(false);
    const [areaClaves, setAreaClaves] = useState({});
    const [tcCodigos, setTcCodigos] = useState({});
    const [horarioCodigos, setHorarioCodigos] = useState({});
    const [periodoClaves, setPeriodoClaves] = useState({});
    const [currentStep, setCurrentStep] = useState(0);

    useEffect(() => {
      return () => {
        if (progressTimer.current) {
          clearInterval(progressTimer.current);
        }
      };
    }, []);

    const filteredItems = React.useMemo(() => {
      const statusFiltered = statusFilter === 'inactive'
        ? (items || []).filter((item) => !item.activo && Boolean(item.nomina_can_reenter))
        : (items || []).filter((item) => Boolean(item.activo));

      const query = (searchText || '').trim().toLowerCase();
      if (!query) {
        return statusFiltered;
      }

      return statusFiltered.filter((item) => {
        const fullName = [
          item?.name,
          item?.nomina_name,
          item?.nomina_first_last_name,
          item?.nomina_second_last_name,
        ]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();

        const employeeNumber = String(item?.nomina_employee_number || '').toLowerCase();
        const curp = String(item?.nomina_curp || '').toLowerCase();
        const rfc = String(item?.nomina_rfc || '').toLowerCase();

        return (
          fullName.includes(query) ||
          employeeNumber.includes(query) ||
          curp.includes(query) ||
          rfc.includes(query)
        );
      });
    }, [items, statusFilter, searchText]);

    const columns = [
      {
        title: 'No. Empleado',
        dataIndex: 'nomina_employee_number',
        key: 'nomina_employee_number',
        sorter: (a, b) => {
          const aValue = Number(a.nomina_employee_number ?? 0);
          const bValue = Number(b.nomina_employee_number ?? 0);
          return aValue - bValue;
        },
        defaultSortOrder: 'ascend',
      },
      {
        title: 'Nombre',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'CURP',
        dataIndex: 'nomina_curp',
        key: 'nomina_curp',
        render: (value) => value || '-',
      },
      {
        title: 'RFC',
        dataIndex: 'nomina_rfc',
        key: 'nomina_rfc',
        render: (value) => value || '-',
      },
      {
        title: 'Fecha Ingreso',
        dataIndex: 'nomina_entry_date',
        key: 'nomina_entry_date',
        render: (value) => {
          if (!value) return '-';
          const parsed = dayjs(value);
          return parsed.isValid() ? parsed.format('DD/MM/YYYY') : value;
        },
      },
      {
        title: 'Puesto',
        dataIndex: 'job_title',
        key: 'job_title',
      },
      {
        title: 'Tipo de nomina',
        dataIndex: 'actions',
        key: 'actions',
        render: (item, object)=> {
          var periodo = object.periodo?.descripcion;
          return <>
          {
            periodo && <Space>{object.periodo.descripcion}</Space>
          }
          </>
        }
      },

    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setPeriodSelected(object);
    }

    const openPasswordModal = async (object)=>{
      setOpenChangePassword(true);
      setPeriodSelected(object);
    }

    const openDetailView = async (object)=>{
      setOpenDetail(true);
      setPeriodSelected(object);
    }

    const onHandlerFinish = async (refresh,  avoidClose) => {
      if(!avoidClose){
        setOpenEdit(false);
         setOpenDetail(false);
      }

      if(refresh){
        await refreshData();
      }
    }

    const onHandlerPasswordFinish = async (refresh) => {
      setOpenChangePassword(false);
      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }
    }

    const executeImport = async (file) => {
      setImporting(true);
      setImportProgress(0);
      if (progressTimer.current) {
        clearInterval(progressTimer.current);
      }
      progressTimer.current = setInterval(() => {
        setImportProgress((prev) => {
          if (prev >= 90) return prev;
          return prev + 5;
        });
      }, 300);
      let shouldStopLoading = true;

      try {
        const response = await importEmpleadosBulk(file, false);

        if (response.ok) {
          const result = response.payload;
          const hasErrors = Array.isArray(result.errors) && result.errors.length > 0;

          if (result.requires_confirmation) {
            shouldStopLoading = false;
            Modal.confirm({
              title: 'Confirmar importación con errores',
              icon: <ExclamationCircleFilled />,
              content: (
                <div>
                  <p>{result.message}</p>
                  <p style={{marginTop: 16}}>Total de registros: <strong>{result.total}</strong></p>
                  <p>Registros exitosos: <strong style={{color: '#52c41a'}}>{result.successful}</strong></p>
                  <p>Registros fallidos: <strong style={{color: '#ff4d4f'}}>{result.failed}</strong></p>
                  {result.errors && result.errors.length > 0 && (
                    <>
                      <p style={{marginTop: 16, fontWeight: 'bold'}}>Errores encontrados (primeros 10):</p>
                      <ul style={{maxHeight: 200, overflow: 'auto', fontSize: '12px', background: '#fafafa', padding: 10, borderRadius: 4}}>
                        {result.errors.map((error, index) => (
                          <li key={index} style={{marginBottom: 4}}>{error}</li>
                        ))}
                      </ul>
                      {result.total_errors > 10 && (
                        <p style={{fontSize: '12px', color: '#888', marginTop: 8}}>
                          ...y {result.total_errors - 10} errores más
                        </p>
                      )}
                    </>
                  )}
                </div>
              ),
              width: 700,
              okText: 'Si, guardar registros exitosos',
              cancelText: 'No, cancelar importación',
              onOk: async () => {
                setImporting(true);
                const confirmedResponse = await importEmpleadosConfirm(result.cached_records);

                if (confirmedResponse.ok) {
                  const confirmedResult = confirmedResponse.payload;
                  if (confirmedResult.saved) {
                    message.success(`Se guardaron correctamente ${confirmedResult.successful} empleados`);
                    await refreshData();
                  }
                }
                setImporting(false);
              },
              onCancel: () => {
                message.info('Importacion cancelada');
                setImporting(false);
              }
            });
          } else {
            const hasValidationIssues = hasErrors || (result.total_errors > 0) || (result.failed > 0);

            if (hasValidationIssues) {
              const firstError = Array.isArray(result.errors) && result.errors.length > 0 ? result.errors[0] : 'Error en la importacion';
              message.error(firstError);
              Modal.warning({
                title: result.total === 0 ? 'Error en la importacion' : 'Importacion completada con errores',
                content: (
                  <div>
                    {result.total > 0 && (
                      <>
                        <p>Total de registros: <strong>{result.total}</strong></p>
                        <p>Exitosos: <strong style={{color: '#52c41a'}}>{result.successful}</strong></p>
                        <p>Fallidos: <strong style={{color: '#ff4d4f'}}>{result.failed}</strong></p>
                      </>
                    )}
                    {result.errors && result.errors.length > 0 && (
                      <>
                        <p style={{marginTop: result.total > 0 ? 16 : 0, fontWeight: 'bold'}}>Errores:</p>
                        <ul style={{maxHeight: 200, overflow: 'auto', fontSize: '12px', background: '#fafafa', padding: 10}}>
                          {result.errors.map((error, index) => (
                            <li key={index}>{error}</li>
                          ))}
                        </ul>
                        {result.total_errors > 10 && (
                          <p style={{fontSize: '12px', color: '#888', marginTop: 8}}>
                            ...y {result.total_errors - 10} errores mas
                          </p>
                        )}
                      </>
                    )}
                  </div>
                ),
                width: 600,
              });
            } else {
              message.success(`Se importaron correctamente ${result.successful} empleados`);
              await refreshData();
            }
          }
        }
      } catch (error) {
        message.error('Error al importar el archivo');
      } finally {
        if (shouldStopLoading) {
          setImporting(false);
        }
        if (progressTimer.current) {
          clearInterval(progressTimer.current);
        }
        setImportProgress(100);
        setTimeout(() => setImportProgress(0), 500);
      }
    };

    const buildSteps = () => {
      if (!previewData) return [];
      const steps = [];
      if ((previewData.missing_departamentos || []).length > 0) {
        steps.push({ key: 'departamentos', title: 'Departamentos' });
      }
      if ((previewData.missing_puestos || []).length > 0) {
        steps.push({ key: 'puestos', title: 'Puestos' });
      }
      if ((previewData.missing_areas || []).length > 0) {
        steps.push({ key: 'areas', title: 'Áreas' });
      }
      if ((previewData.missing_tipos_contrato || []).length > 0) {
        steps.push({ key: 'tipos_contrato', title: 'Tipos Contrato' });
      }
      if ((previewData.missing_horarios || []).length > 0) {
        steps.push({ key: 'horarios', title: 'Horarios' });
      }
      if ((previewData.missing_periodos || []).length > 0) {
        steps.push({ key: 'periodos', title: 'Períodos' });
      }
      return steps;
    };

    const validateCurrentStep = () => {
      const steps = buildSteps();
      if (steps.length === 0) return true;
      const step = steps[currentStep];
      if (!step) return true;

      if (step.key === 'areas') {
        const allHaveClave = (previewData.missing_areas || []).every(
          (a) => areaClaves[a.name]?.trim()
        );
        if (!allHaveClave) {
          message.error('Todas las áreas nuevas deben tener una clave');
          return false;
        }
      }
      if (step.key === 'tipos_contrato') {
        const allHaveCodigo = (previewData.missing_tipos_contrato || []).every(
          (tc) => tcCodigos[tc.name]?.trim()
        );
        if (!allHaveCodigo) {
          message.error('Todos los tipos de contrato nuevos deben tener un código');
          return false;
        }
      }
      if (step.key === 'horarios') {
        const allHaveCodigo = (previewData.missing_horarios || []).every(
          (h) => horarioCodigos[h.name]?.trim()
        );
        if (!allHaveCodigo) {
          message.error('Todos los horarios nuevos deben tener un código corto');
          return false;
        }
      }
      if (step.key === 'periodos') {
        const allHaveClave = (previewData.missing_periodos || []).every(
          (p) => periodoClaves[p.name]?.trim()
        );
        if (!allHaveClave) {
          message.error('Todos los períodos nuevos deben tener una clave SAT');
          return false;
        }
      }
      return true;
    };

    const renderStepContent = () => {
      const steps = buildSteps();
      if (steps.length === 0) return <p>No hay catálogos faltantes.</p>;
      const step = steps[currentStep];
      if (!step) return null;

      if (step.key === 'departamentos') {
        return (
          <div>
            <p style={{marginBottom: 12, color: '#666'}}>
              Los siguientes departamentos serán creados automáticamente:
            </p>
            <ul style={{background: '#fafafa', padding: '8px 16px', borderRadius: 4, margin: 0}}>
              {previewData.missing_departamentos.map((d, i) => (
                <li key={i}>{d.name}</li>
              ))}
            </ul>
          </div>
        );
      }
      if (step.key === 'puestos') {
        return (
          <div>
            <p style={{marginBottom: 12, color: '#666'}}>
              Los siguientes puestos serán creados automáticamente:
            </p>
            <ul style={{background: '#fafafa', padding: '8px 16px', borderRadius: 4, margin: 0}}>
              {previewData.missing_puestos.map((p, i) => (
                <li key={i}>{p.name}</li>
              ))}
            </ul>
          </div>
        );
      }
      if (step.key === 'areas') {
        return (
          <div>
            <p style={{marginBottom: 12, color: '#666'}}>
              Completa la clave para cada área nueva:
            </p>
            {previewData.missing_areas.map((a, i) => (
              <div key={i} style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8}}>
                <span style={{minWidth: 180}}>{a.name}</span>
                <Input
                  placeholder="Clave *"
                  value={areaClaves[a.name] || ''}
                  onChange={(e) => setAreaClaves({...areaClaves, [a.name]: e.target.value})}
                  style={{width: 200}}
                />
              </div>
            ))}
          </div>
        );
      }
      if (step.key === 'tipos_contrato') {
        return (
          <div>
            <p style={{marginBottom: 12, color: '#666'}}>
              Completa el código para cada tipo de contrato nuevo:
            </p>
            {previewData.missing_tipos_contrato.map((tc, i) => (
              <div key={i} style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8}}>
                <span style={{minWidth: 180}}>{tc.name}</span>
                <Input
                  placeholder="Código *"
                  value={tcCodigos[tc.name] || ''}
                  onChange={(e) => setTcCodigos({...tcCodigos, [tc.name]: e.target.value})}
                  style={{width: 200}}
                />
              </div>
            ))}
          </div>
        );
      }
      if (step.key === 'horarios') {
        return (
          <div>
            <p style={{marginBottom: 12, color: '#666'}}>
              Completa el código corto para cada horario nuevo:
            </p>
            {previewData.missing_horarios.map((h, i) => (
              <div key={i} style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8}}>
                <span style={{minWidth: 180}}>{h.name}</span>
                <Input
                  placeholder="Código corto *"
                  value={horarioCodigos[h.name] || ''}
                  onChange={(e) => setHorarioCodigos({...horarioCodigos, [h.name]: e.target.value})}
                  style={{width: 200}}
                />
              </div>
            ))}
          </div>
        );
      }
      if (step.key === 'periodos') {
        return (
          <div>
            <p style={{marginBottom: 12, color: '#666'}}>
              Completa la clave SAT para cada período nuevo:
            </p>
            {previewData.missing_periodos.map((p, i) => (
              <div key={i} style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8}}>
                <span style={{minWidth: 180}}>{p.name}</span>
                <Input
                  placeholder="Clave SAT *"
                  value={periodoClaves[p.name] || ''}
                  onChange={(e) => setPeriodoClaves({...periodoClaves, [p.name]: e.target.value})}
                  style={{width: 200}}
                />
              </div>
            ))}
          </div>
        );
      }
      return null;
    };

    const handlePreviewConfirm = async () => {
      if (!previewData || !previewFile) return;

      const missing = previewData;
      const allAreasHaveClave = (missing.missing_areas || []).every(
        (a) => areaClaves[a.name]?.trim()
      );
      const allTcHaveCodigo = (missing.missing_tipos_contrato || []).every(
        (tc) => tcCodigos[tc.name]?.trim()
      );
      const allHorariosHaveCodigo = (missing.missing_horarios || []).every(
        (h) => horarioCodigos[h.name]?.trim()
      );
      const allPeriodosHaveClave = (missing.missing_periodos || []).every(
        (p) => periodoClaves[p.name]?.trim()
      );

      if (!allAreasHaveClave) {
        message.error('Todas las áreas nuevas deben tener una clave');
        return;
      }
      if (!allTcHaveCodigo) {
        message.error('Todos los tipos de contrato nuevos deben tener un código');
        return;
      }
      if (!allHorariosHaveCodigo) {
        message.error('Todos los horarios nuevos deben tener un código corto');
        return;
      }
      if (!allPeriodosHaveClave) {
        message.error('Todos los períodos nuevos deben tener una clave SAT');
        return;
      }

      setCreatingCatalogs(true);
      try {
        const areasToCreate = (missing.missing_areas || []).map((a) => ({
          name: a.name,
          clave: areaClaves[a.name] || '',
        }));
        const tiposContratoToCreate = (missing.missing_tipos_contrato || []).map((tc) => ({
          name: tc.name,
          codigo: tcCodigos[tc.name] || '',
        }));
        const horariosToCreate = (missing.missing_horarios || []).map((h) => ({
          name: h.name,
          codigo_corto: horarioCodigos[h.name] || '',
        }));
        const periodosToCreate = (missing.missing_periodos || []).map((p) => ({
          name: p.name,
          clave_sat: periodoClaves[p.name] || '',
        }));

        const createResponse = await createMissingCatalogs({
          departamentos: missing.missing_departamentos || [],
          puestos: missing.missing_puestos || [],
          areas: areasToCreate,
          tipos_contrato: tiposContratoToCreate,
          horarios: horariosToCreate,
          periodos: periodosToCreate,
        });

        if (!createResponse.ok) {
          message.error('Error al crear catálogos faltantes');
          setCreatingCatalogs(false);
          return;
        }

        message.success('Catálogos creados correctamente. Procesando importación...');
        setShowPreviewModal(false);
        setPreviewData(null);
        setPreviewFile(null);
        setAreaClaves({});
        setTcCodigos({});
        setHorarioCodigos({});
        setPeriodoClaves({});

        await executeImport(previewFile);
      } catch (error) {
        message.error('Error al crear catálogos faltantes');
      } finally {
        setCreatingCatalogs(false);
      }
    };

    const handleImport = async (file) => {
      setImporting(true);
      setImportProgress(0);
      if (progressTimer.current) {
        clearInterval(progressTimer.current);
      }
      progressTimer.current = setInterval(() => {
        setImportProgress((prev) => {
          if (prev >= 90) return prev;
          return prev + 5;
        });
      }, 300);

      try {
        const previewResponse = await previewImportEmpleados(file);

        if (!previewResponse.ok) {
          message.error('Error al previsualizar el archivo');
          setImporting(false);
          if (progressTimer.current) {
            clearInterval(progressTimer.current);
          }
          setImportProgress(0);
          return false;
        }

        const preview = previewResponse.payload;

        if (preview.validation_errors && preview.validation_errors.length > 0) {
          Modal.error({
            title: 'Errores en el archivo',
            content: (
              <div>
                <ul style={{maxHeight: 200, overflow: 'auto', fontSize: '12px', background: '#fafafa', padding: 10}}>
                  {preview.validation_errors.map((error, index) => (
                    <li key={index} style={{marginBottom: 4}}>{error}</li>
                  ))}
                </ul>
              </div>
            ),
            width: 600,
          });
          setImporting(false);
          if (progressTimer.current) {
            clearInterval(progressTimer.current);
          }
          setImportProgress(0);
          return false;
        }

        const hasMissing =
          (preview.missing_departamentos || []).length > 0 ||
          (preview.missing_puestos || []).length > 0 ||
          (preview.missing_areas || []).length > 0 ||
          (preview.missing_tipos_contrato || []).length > 0 ||
          (preview.missing_horarios || []).length > 0 ||
          (preview.missing_periodos || []).length > 0;

        if (hasMissing) {
          setPreviewData(preview);
          setPreviewFile(file);
          setAreaClaves({});
          setTcCodigos({});
          setHorarioCodigos({});
          setPeriodoClaves({});
          setCurrentStep(0);
          setShowPreviewModal(true);
          setImporting(false);
          if (progressTimer.current) {
            clearInterval(progressTimer.current);
          }
          setImportProgress(0);
          return false;
        }

        await executeImport(file);
      } catch (error) {
        message.error('Error al importar el archivo');
        setImporting(false);
        if (progressTimer.current) {
          clearInterval(progressTimer.current);
        }
        setImportProgress(0);
      }

      return false;
    };

    const downloadTemplate = () => {
      const headers = [
        'nombre','apellido_paterno','apellido_materno',
        'rfc','curp','num_imss',
        'puesto','telefono','email','num_empleado',
        'fecha_ingreso','fecha_antiguedad',
        'fecha_inicio_contrato','fecha_fin_contrato','tipo_contrato',
        'salario_diario','salario_integrado',
        'departamento','puesto_id','area',
        'calle_1','calle_2','ciudad','cp',
        'regimen_salario','clave_registro_empleador',
        'horario','periodo','analitica_id',
        'banco_id','banco_nombre'
      ];

      const row1 = [
        'Juan','Perez','Garcia',
        'PEGJ850101ABC','PEGJ850101HDFRRL09','12345678901',
        'Desarrollador','5551234567','juan.perez@ejemplo.com','E001',
        '2024-01-15','2024-01-15',
        '2024-01-15','','Indefinido',
        '500.00','15000.00',
        'Recursos Humanos','Desarrollador','Tecnologia',
        'Calle Principal 123','Colonia Centro','Ciudad de Mexico','06600',
        'A','EMP001',
        'Turno Matutino','SEMANAL','',
        '',''
      ];

      const row2 = [
        'Maria','Lopez','Rodriguez',
        'LOR850202DEF','LOR850202HDFRRL08','09876543210',
        'Contador','5559876543','maria.lopez@ejemplo.com','E002',
        '2024-02-01','2024-02-01',
        '2024-02-01','','Temporal',
        '600.00','18000.00',
        'Finanzas','Contador','Administracion',
        'Av Reforma 456','Colonia Roma','Guadalajara','44100',
        'B','EMP002',
        'Turno Vespertino','QUINCENAL','',
        '',''
      ];

      const csvContent = headers.join(',') + '\n' + row1.join(',') + '\n' + row2.join(',');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'plantilla_importar_empleados.csv';
      link.click();
    };

    const dropdownItems = [
      {
        key: 'create',
        label: 'Crear empleado',
        icon: <PlusOutlined />,
        onClick: () => {
          setPeriodSelected(null);
          setOpenEdit(true);
        }
      },
      {
        key: 'import',
        label: 'Importar empleados',
        icon: <UploadOutlined />,
        onClick: () => {
          document.getElementById('import-empleado-input').click();
        }
      }
    ];

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    
    return <PageApp routes={routes} title={'Empleados'}>
      <Space>
        <Dropdown menu={{items: dropdownItems}} placement="bottomLeft">
          <Button type="primary" icon={<PlusOutlined />}>
            Empleado
          </Button>
        </Dropdown>
        <Button icon={<DownloadOutlined />} onClick={downloadTemplate}>
          Descargar Plantilla
        </Button>
        <input
          id="import-empleado-input"
          type="file"
          accept=".csv,.xlsx,.xls"
          style={{display: 'none'}}
          onChange={(e) => {
            const file = e.target.files[0];
            if (file) {
              handleImport(file);
              e.target.value = null;
            }
          }}
        />
        <Input
          allowClear
          value={searchText}
          onChange={(event) => setSearchText(event.target.value)}
          placeholder="Buscar por nombre, no. empleado, CURP o RFC"
          style={{ width: 360 }}
        />
        <Segmented
          value={statusFilter}
          onChange={setStatusFilter}
          options={[
            { label: 'Activos', value: 'active' },
            { label: 'bajas', value: 'inactive' },
          ]}
        />
      </Space>

      {importing && (
        <div style={{maxWidth: 400, marginTop: 16}}>
          <Progress percent={importProgress} status={importProgress >= 100 ? 'success' : 'active'} />
        </div>
      )}

      <Divider/>
      {
          filteredItems.length == 0 ? <Empty />:
          <Table
            dataSource={filteredItems}
            columns={columns}
            rowKey={(record) => record.id}
            onRow={(record) => ({
              onClick: () => openDetailView(record),
              style: { cursor: 'pointer' },
            })}
          />
      }
      {
        (openEdit && periodSelected && periodSelected.id > 0) &&
        <ModalEdit title={"Editar Empleado"} id={periodSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !periodSelected) &&
        <ModalEdit title={"Crear Empleado"} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openDetail && periodSelected && periodSelected.id > 0) &&
        <EmpleadoDetail title={"Detalle del Empleado"} id={periodSelected.id} open={openDetail} finish={onHandlerFinish} employeesViewFilter={statusFilter}/>
      }
      {
        (openChangePassword && periodSelected && periodSelected.id > 0) &&
        <ChangePasswordModal id={periodSelected.id} open={openChangePassword} finish={onHandlerPasswordFinish}/>
      }
      <Modal
        title="Catálogos faltantes"
        open={showPreviewModal}
        onOk={() => {
          const steps = buildSteps();
          if (currentStep < steps.length - 1) {
            if (validateCurrentStep()) {
              setCurrentStep(currentStep + 1);
            }
          } else {
            handlePreviewConfirm();
          }
        }}
        onCancel={() => {
          setShowPreviewModal(false);
          setPreviewData(null);
          setPreviewFile(null);
          setAreaClaves({});
          setTcCodigos({});
          setCurrentStep(0);
        }}
        okText={currentStep < buildSteps().length - 1 ? 'Siguiente' : 'Crear y continuar'}
        cancelText={currentStep > 0 ? 'Anterior' : 'Cancelar'}
        confirmLoading={creatingCatalogs}
        width={700}
        footer={previewData ? (
          <div style={{display: 'flex', justifyContent: 'flex-end', gap: 8}}>
            <Button onClick={() => {
              if (currentStep > 0) {
                setCurrentStep(currentStep - 1);
              } else {
                setShowPreviewModal(false);
                setPreviewData(null);
                setPreviewFile(null);
                setAreaClaves({});
                setTcCodigos({});
                setCurrentStep(0);
              }
            }}>
              {currentStep > 0 ? 'Anterior' : 'Cancelar'}
            </Button>
            <Button
              type="primary"
              loading={creatingCatalogs}
              onClick={() => {
                const steps = buildSteps();
                if (currentStep < steps.length - 1) {
                  if (validateCurrentStep()) {
                    setCurrentStep(currentStep + 1);
                  }
                } else {
                  handlePreviewConfirm();
                }
              }}
            >
              {currentStep < buildSteps().length - 1 ? 'Siguiente' : 'Crear y continuar'}
            </Button>
          </div>
        ) : undefined}
      >
        {previewData && (
          <div>
            <Steps
              current={currentStep}
              size="small"
              style={{marginBottom: 24}}
              items={buildSteps().map((s) => ({title: s.title}))}
            />
            {renderStepContent()}
          </div>
        )}
      </Modal>
    </PageApp>
}   

export default EmpleadosPage;
